var map = {
	"./black/yichu.png": "BdBR",
	"./blue/yichu.png": "koWS",
	"./white/yichu.png": "yapf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nggW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/yichu\.png$
// module id = nggW
// module chunks = 24